<template>
  <div class="d-flex align-center justify-center fill-height" v-if="loading">
    <Loader label="Загрузка данных системы лицензирования..." />
  </div>
  <div v-else-if="gsa" class="d-flex flex-column fill-height">
    <v-card-title>
      <v-btn
        icon
        large
        class="mr-5"
        @click="back"
      >
        <v-icon>mdi-arrow-left</v-icon>

      </v-btn>
      
      Редактирование: {{gsa.comment}} <StatusDip class="ml-5" :status="gsa.status" :version="gsa.version"/> 
      <span style="margin-left: 1em; font-size: .6em; opacity: .5;">{{gsa.version ? 'GSA v'+gsa.version : ''}}</span>
    </v-card-title>
    <v-card-subtitle v-if="gsa.deleted" class="red--text">
      <v-icon small color="red" class="mr-1">mdi-alert</v-icon>
      Объект удален
    </v-card-subtitle>
    <v-card-text style="flex-grow: 1">
      <v-row>
        <v-col>
          <TextField
            disabled
            label="ID" 
            :value="''+local.id" 
          />

        </v-col>
        <v-col>
          <TextField
            disabled
            copyvalue
            label="GUID" 
            v-model="local.guid" 
          />
        </v-col>
        <v-col>
          <TextField
            disabled
            copyvalue
            label="Рестриктор" 
            v-model="local.key" 
          />
        </v-col>
      </v-row>
      <v-row v-if="edit">
        <v-col>
          <TextField
            disabled
            label="Дилер" 
            :extlink="'https://lic.carbis.ru/dealers/'+master_data.dealerId"
            :value="`(${master_data.dealerId}) ${master_data.dealerName}`" 
          />

        </v-col>
        <v-col>
          <TextField
            disabled
            label="Объект" 
            :extlink="'https://lic.carbis.ru/objects/'+master_data.objectId"
            :value="`(${master_data.objectId}) ${master_data.objectName}`" 
          />
        </v-col>
        <v-col cols="2">
          <TextField
            disabled
            label="Мастер-лицензия" 
            :extlink="'https://lic.carbis.ru/masters/'+local.master_id"
            :value="''+local.master_id" 
          />
        </v-col>
        <v-col>
          <TextField
            disabled
            label="Модуль ПО" 
            :value="`(${master_data.moduleId}) ${master_data.moduleName}`" 
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <TextField
            label="Название"
            counter="200"
            v-model="local.comment"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-btn @click="show_connection=true" color="green" dark class="ml-3">
          <v-icon small>mdi-connection</v-icon> 
          Получить токен подключения
        </v-btn>
        <v-btn 
          class="ml-5"
          color="green" 
          :dark="!offline"
          :title="offline ? 'Удаленная конфигурация невозможна' : ''"
          :disabled="offline"
          @click="start_remote"
        >
          <v-icon small>mdi-remote-desktop</v-icon> 
          Конфигурировать удаленно
        </v-btn>
        <v-spacer></v-spacer>
        
        <v-btn @click="ask_delete" v-if="!gsa.deleted" :loading="saving" color="red" text class="ml-3">
          <v-icon small>mdi-delete</v-icon> 
          Удалить GSA
        </v-btn>
        <v-btn @click="ask_restore" v-else color="red" text class="ml-3">
          <v-icon small>mdi-backup-restore</v-icon> 
          Восстановить GSA
        </v-btn>
      </v-row>
      
    </v-card-text>
    <v-card-actions>
      <v-btn
        text
        color="green"
        @click="save_update"
        :loading="saving"
      >
        <v-icon small>mdi-content-save</v-icon>
        Сохранить
      </v-btn>
    </v-card-actions>
    <Approvement ref="approver" />
    <GsaConnection
      :gsa="gsa"
      :value="show_connection"
      @input="e => show_connection = e"
    />

    <v-dialog v-model="remote_config" scrollable max-width="800px" max-height="800px">
      <RemoteConfigurator @greet="greet = true" @close="remote_config = false" v-if="remote_config" :agent_guid="gsa.guid" />
    </v-dialog>

    <v-snackbar
      :timeout="3000"
      v-model="greet"
      color="green"
    >
      <v-icon>mdi-check</v-icon>
      Изменения успешно сохранены
    </v-snackbar>
  </div>
</template>

<script>
import Loader from './ui/Loader.vue'
import TextField from './ui/TextField.vue'
import StatusDip from './ui/StatusDip.vue'
import GsaConnection from './GsaConnection.vue'
import Approvement from './ui/Approvement.vue'
import RemoteConfigurator from './RemoteConfigurator.vue'
import  { mapGetters } from 'vuex'

export default {
  data: () => ({
    saving: false,
    loading: false,
    show_connection: false,
    local: {},
    greet: false,
    remote_config: false,
    source: undefined
  }),
  methods:{
    async start_remote(){
      this.remote_config = true
    },
    back(){
      this.$router.replace('/gsa')
    },
    async load_data(){
      this.loading = true
      await Promise.all([
        this.$store.dispatch('load_objects'),
        this.$store.dispatch('load_dealers')
      ])
      this.loading = false
    },
    async ask_delete(){
      let r = await this.$refs.approver.ask(
        `Вы действительно хотите удалить GSA "${this.gsa.comment}"?`,
        'удалить',
        'mdi-delete'
      )

      if (r) {
        this.saving = true
        await this.$store.dispatch('delete_gsa', this.gsa.id)
        this.saving = false
        this.greet = true
      }
    },
    async ask_restore(){
      let r = await this.$refs.approver.ask(
        `Вы действительно хотите восстановить GSA "${this.gsa.comment}"?`,
        'восстановить',
        'mdi-backup-restore'
      )

      if (r) {
        this.saving = true
        await this.$store.dispatch('restore_gsa', this.gsa.id)
        this.saving = false
        this.greet = true
      }
    },
    async save_update(){
      this.saving = true
      try {
        await this.$store.dispatch('update_gsa', this.local)
        
      } catch (e) {
        console.error(e)
      }
      this.local = this.gsa
      this.saving = false
      this.greet = true
    },
    onMessage(e){
      console.log(e.data)
      let r = JSON.parse(e.data)
      
      if (r.message == 'StatusMessage') {
        if (r.payload == 'DISCONNECTED') {
          this.remote_config = false
        }
        this.$store.commit('update_gsa', {...this.gsa, status: r.payload})
      }
    },
    subscribe(agent){
      if (this.source == undefined) {
        this.source = new EventSource(this.$store.getters.url+'/api/v1/gsa/feedstatus?agent_guid='+agent.guid)
        this.source.addEventListener('message', this.onMessage)
        console.log('sub', agent.guid)
      }
    },
    unsubscribe(){
      
      if (this.source) {
        this.source.removeEventListener('message', this.onMessage)
        this.source.close()
        console.log('unsub')
      }
      this.source = undefined
    }
  },
  watch:{
    gsa(val){

      if (val && (val.deleted == false) ) {
        this.local = this.gsa
        this.subscribe(val)
      } else {
        this.unsubscribe()
        this.greet = false
      }
    }
  },
  computed:{
    ...mapGetters(['master', 'dealer', 'object']),
    master_data(){
      return this.master(this.gsa.master_id)
    },
    offline(){
      return (this.gsa.status == 'DISCONNECTED') || (this.gsa.status == null)
    }
  },
  beforeDestroy(){
    this.unsubscribe()
  },
  async mounted(){
    this.local = this.gsa
    this.subscribe(this.local)
    this.greet = false
  },
  props:{
    gsa: Object,
    edit: Boolean
  },
  components:{
    Loader,
    TextField,
    StatusDip,
    GsaConnection,
    Approvement,
    RemoteConfigurator
  }
}
</script>

<style scoped>
/* .col {
  padding: 5px;
} */

.v-text-tails {
  display: none !important;
}
</style>